module.exports = __webpack_public_path__ + "img/flechafooter.d017f589.svg";